import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';
import { getRoles } from 'store/actions'; 
import RoleTable from './RolesTable';
import Breadcrumb from 'components/Common/Breadcrumb2';


const RoleList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const roles = useSelector((state) => state.Role.roles);
    const loading = useSelector((state) => state.Role.loading);
    const error = useSelector((state) => state.Role.error);

    const permissions2 = JSON.parse(localStorage?.getItem('permissions'));

    // Dispatch action to fetch roles when component mounts
    useEffect(() => {
        if(loading)return;
        dispatch(getRoles());
        
    }, []);

    return (
        <>
            <div className="page-content container-fluid">
                <div className="d-flex justify-content-between align-items-center mx-3">
                    <Breadcrumb title="Roles" breadcrumbItems={[{ title: "Dashboard", link: `/dashboard` }, { title: "Roles", link: '#' }]} />
                    {permissions2?.map(item=>item?.permissionName)?.includes("Add Roles")  && <Button 
                        className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center" 
                        onClick={() => navigate('/createRole')} 
                    >
                        <i className="ti-plus"></i> Add New
                    </Button>}
                </div>
                
                {/* Display loading state, error message, or the list of roles */}

                    <RoleTable loading={loading} List={roles?.Data} />  

            </div>
        </>
    );
};

export default RoleList;
